import { render, staticRenderFns } from "./Channels.vue?vue&type=template&id=5cdd7c74&scoped=true"
import script from "./Channels.vue?vue&type=script&lang=js"
export * from "./Channels.vue?vue&type=script&lang=js"
import style0 from "./Channels.vue?vue&type=style&index=0&id=5cdd7c74&prod&scoped=true&lang=scss"
import style1 from "./Channels.vue?vue&type=style&index=1&id=5cdd7c74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdd7c74",
  null
  
)

export default component.exports